const SiteFooter = () => (
  <footer className="bg-muted/30 py-8 text-center text-sm text-muted-foreground border-t border-border">
    <div className="container px-4 md:px-6">
      <p>© 2026 Glow Up LEADership Academy, LLC. All rights reserved.</p>
      <a
        href="https://minarvo.com"
        target="_blank"
        rel="noopener noreferrer"
        className="underline"
      >
        Powered by MINARVO
      </a>
    </div>
  </footer>
);

export default SiteFooter;
